// Welcome screen: first screen of the placement wizard.

import { MaskedName } from '@/lib/privacyMask'
import '@/styles/placement-flow.css'

interface WelcomeScreenProps {
  learnerName: string
  onStart: () => void
  submitting?: boolean
}

export function WelcomeScreen({
  learnerName,
  onStart,
  submitting = false,
}: WelcomeScreenProps) {
  return (
    <div className="welcome-screen">
      <div className="hs-eyebrow welcome-screen__eyebrow">
        <MaskedName>{learnerName}</MaskedName>&rsquo;s placement
      </div>

      <h1 className="welcome-screen__title">
        Let&rsquo;s get to know your{' '}
        <span className="welcome-screen__highlight">
          <span aria-hidden="true" className="welcome-screen__highlight-mark" />
          <span className="welcome-screen__highlight-text">reader</span>
        </span>
        .
      </h1>

      <p className="welcome-screen__copy">
        A few quick questions about how <MaskedName>{learnerName}</MaskedName> reads, then we&rsquo;ll look at some words
        together to find the right starting level.
      </p>

      <p className="welcome-screen__caption">
        Takes about 3 to 5 minutes.
      </p>

      <button
        type="button"
        onClick={onStart}
        disabled={submitting}
        className="hs-press welcome-screen__cta"
      >
        {submitting ? 'Starting...' : <>Find <MaskedName>{learnerName}</MaskedName>&rsquo;s level</>}
        <svg
          width="19"
          height="19"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M3 10h13M11 4l6 6-6 6" />
        </svg>
      </button>
    </div>
  )
}
